import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import useAPI from '../../api';
import Funnel from './Components/Funnel';
import FiltersNavbar from './Components/FiltersNavbar';
import ContentError from '../../Components/Error/ContentError';
import { useIntl } from 'react-intl';

const FunnelReportPage = function FunnelReportPage() {
  const API = useAPI();
  const intl = useIntl();
  const [data, setData] = useState(null);
  const [filters, setFilters] = useState({
    branchIds: [],
    campaignId: '',
  });

  const loadDividers = () => {
    API.getCampaignDividers(
      (result) => {
        result.sort((a, b) => a.advancementThreshold - b.advancementThreshold);
        setData(result);
      },
      () => {}
    );
  };
  useEffect(() => {
    if (!filters?.campaignId) {
      loadDividers();
    }
    if (filters?.campaignId) {
      const { campaignId, ...restFilters } = filters || {};

      API.getCampaignFunnel(
        campaignId,
        restFilters,
        (res) => {
          if (res?.length > 0) setData(res);
          else {
            loadDividers();
          }
        },
        () => {}
      );
    }
  }, [filters]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100%",
        overflow: "hidden"
      }}>
      <FiltersNavbar
        defaultBranches={filters.branchIds}
        defaultCampaign={filters.campaignId}
        onSubmit={setFilters}
      />
      {data ? (
        <Funnel
          stages={data}
          total={data.reduce((acc, stage) => acc + stage?.customersCount, 0)}
        />
      ) : (
        <ContentError text={intl.messages.NO_DATA_AVAILABLE} />
      )}
    </Box>
  );
};

export default FunnelReportPage;
